const ALT_C_FOCUS_RETURN_KEY = "__altCFocusReturn";

const escapeSelectorValue = (value = "") =>
  String(value).replace(/\\/g, "\\\\").replace(/"/g, '\\"');

const findFallbackTarget = (context) => {
  if (!context) {
    return null;
  }

  if (context.targetId) {
    const byId = document.getElementById(context.targetId);
    if (byId) {
      return byId;
    }
  }

  if (context.targetName) {
    const byName = document.querySelector(
      `[name="${escapeSelectorValue(context.targetName)}"]`,
    );
    if (byName) {
      return byName;
    }
  }

  return null;
};

const getActiveInputElement = () => {
  const activeElement = document.activeElement;
  if (!activeElement || activeElement === document.body) {
    return null;
  }

  return activeElement;
};

export const registerAltCFocusReturn = (modalId) => {
  if (!modalId) {
    return;
  }

  const target = getActiveInputElement();
  if (!target) {
    return;
  }

  let selectionStart = null;
  let selectionEnd = null;
  if (target.tagName === "INPUT" || target.tagName === "TEXTAREA") {
    try {
      selectionStart = target.selectionStart;
      selectionEnd = target.selectionEnd;
    } catch (e) {
      selectionStart = null;
      selectionEnd = null;
    }
  }

  window[ALT_C_FOCUS_RETURN_KEY] = {
    modalId,
    target,
    targetId: target.id || "",
    targetName: target.getAttribute("name") || "",
    selectionStart,
    selectionEnd,
    createdAt: Date.now(),
  };
};

export const restoreAltCFocusReturn = (modalId) => {
  if (!modalId) {
    return;
  }

  const context = window[ALT_C_FOCUS_RETURN_KEY];
  if (!context || context.modalId !== modalId) {
    return;
  }

  delete window[ALT_C_FOCUS_RETURN_KEY];
  const { selectionStart, selectionEnd } = context;
  const maxAttempts = 8;
  const retryDelayMs = 30;

  window.isRestoringVoucherFocus = true;

  const clearRestoreFlag = () => {
    window.isRestoringVoucherFocus = false;
  };

  const tryRestore = (attempt = 0) => {
    try {
      const target =
        context.target && document.body.contains(context.target)
          ? context.target
          : findFallbackTarget(context);

      if (!target) {
        if (attempt >= maxAttempts) {
          clearRestoreFlag();
          return;
        }
        setTimeout(() => tryRestore(attempt + 1), retryDelayMs);
        return;
      }

      target.focus();
      if (
        selectionStart !== null &&
        selectionEnd !== null &&
        (target.tagName === "INPUT" || target.tagName === "TEXTAREA")
      ) {
        target.setSelectionRange(selectionStart, selectionEnd);
      }
      clearRestoreFlag();
    } catch (e) {
      if (attempt >= maxAttempts) {
        clearRestoreFlag();
        return;
      }
      setTimeout(() => tryRestore(attempt + 1), retryDelayMs);
    }
  };

  setTimeout(() => {
    tryRestore(0);
  }, 0);
};
